import lodashGet from 'lodash/get';
import { addToExperiments } from './addToExperiments';
/**
 * Get 2D experiments containing zones.
 *
 * @param {Spectra} spectraData
 */
export function getExperiments2D(experiments) {
    const _experiments2D = {};
    Object.keys(lodashGet(experiments, '2D', {})).forEach((experimentType) => {
        addToExperiments(experiments, _experiments2D, `2D.${experimentType}`, false, experimentType);
    });
    return _experiments2D;
}
//# sourceMappingURL=getExperiments2D.js.map